import { render, staticRenderFns } from "./FreescoutLogo.vue?vue&type=template&id=2d7048a6"
import script from "./FreescoutLogo.vue?vue&type=script&lang=js"
export * from "./FreescoutLogo.vue?vue&type=script&lang=js"
import style0 from "./FreescoutLogo.vue?vue&type=style&index=0&id=2d7048a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports